import { all, fork, select, spawn, take } from 'redux-saga/effects';
import { NOT_FOUND } from 'redux-first-router';

import { getLocationType } from '../reducers/location';
import * as routeTypes from '../routes/types';

// Route Sagas
import analytics from './analytics';
import app from './app';
import events from './events';
import search from './search';
import tara from './tara';

const allSagas = function* () {
  yield all([
    ...app,
    ...analytics,
    ...events,
    ...search,
    ...tara,
  ]);
};

// Routes that require side effects on load are mapped here, type to saga.
const routesMap = {
  [NOT_FOUND]: allSagas,
};

Object.keys(routeTypes).forEach((route) => {
  routesMap[routeTypes[route]] = allSagas;
});

const sagasLoaded = {};
const containerSagasLoaded = {};

Object.keys(routesMap).forEach((key) => {
  sagasLoaded[key] = false;
  if (routesMap[key]) {
    containerSagasLoaded[routesMap[key].name] = false;
  }
});

// On application boot we check state to see if we should load anything, then
// we watch for future changes.
function* routes() {
  const initialRoute = yield select(getLocationType);
  // Run saga in route map that matches initialRoute if exists
  if (routesMap[initialRoute]) {
    sagasLoaded[initialRoute] = true;
    containerSagasLoaded[routesMap[initialRoute].name] = true;
    yield spawn(routesMap[initialRoute]);
  }
  // Watch for future navigation events and run the correct saga if needed.
  while (true) {
    const { type } = yield take(Object.keys(routesMap));

    if (!sagasLoaded[type] && !containerSagasLoaded[routesMap[type].name]) {
      sagasLoaded[type] = true;
      containerSagasLoaded[routesMap[type].name] = true;
      yield spawn(routesMap[type]);
    }
  }
}

export default function* sagas() {
  yield fork(routes);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js